import type { ReactNode } from "react";
import { Check } from "lucide-react";

/**
 * Affirmative check row in brand pink — the handoff's brand rule for this
 * page: affirmative marks are pink, never green (amber = honest roadmap,
 * cyan = mono syntax only), so the kit's green CheckItem stays out.
 */
export default function PinkCheck({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-start gap-3">
      <span className="mt-px flex h-[19px] w-[19px] flex-none items-center justify-center rounded-full border border-brand-600/30 bg-brand-600/[0.09] text-brand-600">
        <Check size={10} strokeWidth={3} aria-hidden="true" />
      </span>
      <span className="text-[14px] leading-[1.5] text-muted [text-wrap:pretty]">{children}</span>
    </div>
  );
}
